import { render, staticRenderFns } from "./automaticRuleEditor.vue?vue&type=template&id=679da039&scoped=true&"
import script from "./automaticRuleEditor.vue?vue&type=script&lang=js&"
export * from "./automaticRuleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679da039",
  null
  
)

export default component.exports